module.exports = __webpack_public_path__ + "static/sonia-report-sc-1d06958cae942f0f99e96de5dbeb591c.png";